import styled from "styled-components";
import { theme } from "../../styles/theme";

export const ScrollUpContainer = styled("button")`
  padding: 12px;
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 100;
  cursor: pointer;
  background: ${theme.colors.white};
  border: 1px solid ${theme.colors.border};
  text-align: center;
  align-items: center;
  border-radius: 50%;
  transition: all 0.25s ease;
  display: flex;
  box-shadow: ${theme.shadow.card};

  &:hover,
  &:focus-visible {
    background: ${theme.colors.backgroundAlt};
    border-color: ${theme.colors.brown};
    transform: translateY(-2px);
  }
`;
